import { createBrowserRouter } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/home/HomePage";
import ShopPage from "@/pages/shop/ShopPage";
import ProductList from "@/pages/shop/components/ProductList";
import ProductDetailPage from "@/pages/product-detail/ProductDetailPage";
import CartPage from "@/pages/cart/CartPage";
import CheckoutPage from "@/pages/checkout/CheckoutPage";
import OrderPayPage from "@/pages/order-pay/OrderPayPage";
import OrderPage from "@/pages/order/OrderPage";
import OrderReceivedPage from "@/pages/order-received/OrderReceivedPage";
import ShoppingInfoPage from "@/pages/shopping-info/ShoppingInfoPage";
import ReturnPolicyPage from "@/pages/return-policy/ReturnPolicyPage";
import PrivacyPolicyPage from "@/pages/privacy-policy/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/terms-of-service/TermsOfServicePage";
import ErrorBoundary from "@/components/ui/errors/ErrorBoundary";
import NotFound from "@/components/ui/errors/NotFound";
import ProjectPage from "@/pages/project/ProjectPage";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Layout />,
		errorElement: <ErrorBoundary />,
		children: [
			{
				index: true,
				element: <HomePage />,
			},
			{
				path: "shop",
				element: <ShopPage />,
				children: [
					{
						index: true,
						element: <ProductList />,
					},
				],
			},
			{
				path: "product-category/:categorySlug", // 超過2層改 "product-category/*" 在元件內自行解析路徑
				element: <ShopPage />,
				children: [
					{ index: true, element: <ProductList /> },
					{
						path: ":subCategorySlug",
						element: <ProductList />,
					},
				],
			},
			{
				path: "product/:productSlug",
				element: <ProductDetailPage />,
			},
			{
				path: "cart",
				element: <CartPage />,
			},
			{
				path: "checkout",
				element: <CheckoutPage />,
			},
			{
				path: "checkout/order-pay/:orderId",
				element: <OrderPayPage />,
			},
			{
				path: "checkout/order-received/:orderId",
				element: <OrderReceivedPage />,
			},
			{
				path: "order",
				element: <OrderPage />,
			},
			{
				path: "shopping-info",
				element: <ShoppingInfoPage />,
			},
			{
				path: "return-policy",
				element: <ReturnPolicyPage />,
			},
			{
				path: "privacy-policy",
				element: <PrivacyPolicyPage />,
			},
			{
				path: "terms-of-service",
				element: <TermsOfServicePage />,
			},
			{
				path: "project",
				element: <ProjectPage />,
			},
			{
				path: "*",
				element: <NotFound />,
			},
		],
	},
]);

export default router;
